import React from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
// eslint-disable-next-line import/no-extraneous-dependencies
import { createBrowserHistory } from 'history';
import configData from '../config.json';

const browserHistory = createBrowserHistory({ basename: '' });
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: configData.APPINSIGHTS_CONNECTION_STRING,
    enableAutoRouteTracking: true,
    appId: 'Airswift.UI',
    loggingLevelConsole: 1,
    loggingLevelTelemetry: 2,
    autoTrackPageVisitTime: true,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    enableAjaxErrorStatusText: true,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory }
    },
    correlationHeaderExcludedDomains: ['*.ads.linkedin.com'],
    disableAjaxTracking: false,
    ajaxIgnorePatterns: [
      /google-analytics\.com\/g\/collect/,
      /gtag\/js/,
      /analytics\.google\.com/,
      /api\.stonly\.com/,
      /px\.ads\.linkedin\.com/
    ]
  }
});

const thirdPartyDomains = [
  "px.ads.linkedin.com",
  "google-analytics.com",
  "analytics.google.com",
  "google.com",
  "hubspot.com",
  "googleapis.com",
  "hubapi.com",
  "consentmanager.net",
  "hs-banner.com",
  "api.stonly.com",
  "stonly.com",
  "clarity.ms",
];

appInsights.loadAppInsights();

appInsights.trackPageView();

appInsights.addTelemetryInitializer((envelope) => {
  if (envelope && envelope.tags) {
    envelope.tags['ai.cloud.role'] = 'AirSwift.UI';
    envelope.tags['ai.cloud.roleInstance'] = 'AirSwift.UI';
  }
});

appInsights.addTelemetryInitializer((envelope) => {

  if (envelope && envelope?.baseData) {
    const baseData = envelope?.baseData;

    const searchString =
      baseData.message || baseData.target || JSON.stringify(baseData);

    const isThirdParty = thirdPartyDomains.some(domain =>
      searchString.includes(domain)
    );


    if (isThirdParty) {
      return false;
    }
  }
});

appInsights.addTelemetryInitializer((envelope) => {
  const url = envelope?.baseData?.target || envelope?.baseData?.url || "";

  const isThirdParty = thirdPartyDomains.some(domain => url.includes(domain));
  if (isThirdParty) {
    envelope.baseData.properties = {
      ...envelope.baseData.properties,
      ErrorSource: "ThirdParty",
    };
    envelope.tags["ai.cloud.roleInstance"] = "ThirdParty";
  }
});

export default (Component) => withAITracking(reactPlugin, Component);
export { reactPlugin, appInsights };
